<template>
  <div>
    <v-dialog v-model="orderStateDialog" max-width="335">
      <div v-if="count > 0">
        <v-card>
          <v-card-title class="coggiri-middle-subject pt-5 pl-5 pb-3"
            >멤버십 설정 삭제</v-card-title
          >

          <v-row class="pt-0 pb-0 col-xl-12 col-lg-12 ml-0 mr-0 mb-0 pl-5 pr-5">
            <div
              style="background-color: rgb(248, 248, 248); width:100%;"
              class="pa-3"
            >
              <p class="membershipSettingTextInfo mb-0">
                [멤버십명]
              </p>
              <p class="membershipSettingTextInfo mb-0">
                - 현재 사용중 회원 {{ count }}명
              </p>
            </div>
          </v-row>

          <v-card-text class="pa-5">
            <p class="membershipSettingTextDetailInfo mb-0">
              현재 사용중인 회원이 있습니다.
            </p>
            <p class="membershipSettingTextDetailInfo mb-0 mt-2 primary--text">
              삭제를 위해서는 회원별 멤버십 해지처리 후
            </p>
            <p class="membershipSettingTextDetailInfo mb-0">
              <font class="primary--text">삭제가 가능</font>합니다.
            </p>
            <p class="membershipSettingTextDetailInfo mb-2">
              <font class="primary--text"
                >판매여부를 변경하여 사용하시길 권장</font
              >합니다.
            </p>
          </v-card-text>

          <v-btn
            color="black"
            hide-details
            depressed
            class="ml-5 mb-5 white--text"
            @click="orderStateDialog = false"
            width="138"
            >닫기</v-btn
          >

          <v-btn
            color="primary"
            hide-details
            class="white--text ml-2 mb-5 pl-4 pr-4 mr-5"
            depressed
            @click="cancelMenuMove()"
            width="139"
            >해지 메뉴 이동</v-btn
          >
        </v-card>
      </div>

      <div v-else>
        <v-card>
          <v-card-title class="coggiri-middle-subject pt-5 pl-5 pb-3 "
            >멤버십 설정 삭제</v-card-title
          >

          <v-row class="pt-0 pb-0 col-xl-12 col-lg-12 ml-0 mr-0 mb-0 pl-5 pr-5">
            <div
              style="background-color: rgb(248, 248, 248); width:100%;"
              class="pa-3"
            >
              <p class="membershipSettingTextInfo mb-0 ">
                [멤버십명]
              </p>
              <p class="membershipSettingTextInfo mb-0">
                - 현재 사용중 회원 {{ count }}명
              </p>
            </div>
          </v-row>

          <v-card-text class="pa-5">
            <p class="membershipSettingTextDetailInfo mb-0">
              현재 사용중인 회원이 없습니다.
            </p>

            <p class="membershipSettingTextDetailInfo mb-0 mt-2">
              삭제 버튼을 클릭시
            </p>
            <p class="membershipSettingTextDetailInfo mb-0">
              <font class="primary--text"
                >카페24에 등록된 유료 멤버십 상품이 삭제</font
              >되며
            </p>
            <p class="membershipSettingTextDetailInfo mb-2">
              관련된 모든 설정 사항이 삭제됩니다.
            </p>
            <p class="membershipSettingTextDetailInfo mb-2">
              삭제 처리하시겠습니까?
            </p>
          </v-card-text>

          <v-btn
            color="black"
            hide-details
            depressed
            class="ml-5 mb-5 white--text"
            @click="orderStateDialog = false"
            width="143"
            >닫기</v-btn
          >

          <v-btn
            color="primary"
            hide-details
            class="white--text ml-2 mb-5 pl-4 pr-4 mr-5"
            depressed
            @click="cancel()"
            width="144"
            >삭제</v-btn
          >
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>

<style scoped>
.membershipSettingTextInfo {
  font-size: 0.875rem;
  color: #6c757d;
  font-weight: 600;
}
.membershipSettingTextDetailInfo {
  font-size: 0.875rem;
  color: #6c757d;
  font-weight: 400;
}
</style>

<script>
import M from "@/libs/mapping.js";
export default {
  data: () => {
    return {
      orderStateDialog: false,
      id: 0,
      count: 0,
    };
  },
  methods: {
    show: async function(id, count) {
      this.id = id;
      this.count = count;
      this.orderStateDialog = true;
    },

    cancel: async function() {
      try {
        await M.api(M.entry("/del/membership", this.id));
        alert("삭제되었습니다.");

        let info = this.$parent.membership_service.find(
          (service) => service.membership_id === this.id
        );

        const index = this.$parent.membership_service.indexOf(info);
        this.$parent.membership_service.splice(index, 1);
        this.orderStateDialog = false;
      } catch (e) {
        alert("삭제 하지 못했습니다");
      }
    },
    cancelMenuMove: function() {
      this.$router.push({
        path: `/membership/${this.$store.state.mallId}/order`,
      });
    },
  },
};
</script>
